
import { window } from 'globalthis/implementation';
import React from 'react';
import View from "./view"
import Page from "src/components/Page";
import { Helmet } from 'react-helmet';
function index(props) {
    localStorage.removeItem("@storeAuctionLot");
   
    return (
        <>
        {/* <Helmet>

      <meta itemprop="name" content="Current & Past Art Exhibitions | Leon Gallery Manila" />
    <meta property="og:title" content="Current & Past Art Exhibitions | Leon Gallery Manila" />
    <meta name="twitter:title" content="Current & Past Art Exhibitions | Leon Gallery Manila" />
    <meta itemprop="description" content="Explore Leon Gallery’s curated art exhibitions in Manila, featuring renowned Filipino artists and historic collections. View current, upcoming, and past shows." /> 
    <meta property="og:description" content="Explore Leon Gallery’s curated art exhibitions in Manila, featuring renowned Filipino artists and historic collections. View current, upcoming, and past shows." />  
    <meta name="twitter:description" content="Explore Leon Gallery’s curated art exhibitions in Manila, featuring renowned Filipino artists and historic collections. View current, upcoming, and past shows." />
    <meta itemprop="image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" /> 
<meta property="og:image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" />
<meta name="twitter:image" content="https://leon-gallery.com/static/media/logo.df0c3dbcff15cc21dae9.jpg" /> 
        </Helmet> */}
        <Page  >
            <View/>
        </Page>
        </>
    );
}

export default index;